// src/components/AddEquipmentModal.jsx
import React, { useState } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button } from 'antd';

const AddEquipmentModal = ({
  isAddModalOpen,
  handleAddCancel,
  addForm,
  handleAddEquipment,
}) => {
  // Локальное состояние для контроля блокировки выбора дат
  const [disabledDates, setDisabledDates] = useState({
    to1: false,
    to2: false,
    to3: false,
    majorRepair: false,
    verification: false,
    calibration: false,
    testing: false,
  });

  const handleFrequencyChange = (field, value) => {
    setDisabledDates((prev) => ({
      ...prev,
      [field]: value === 'Н/У', // Блокируем дату, если выбрано "Не указано"
    }));
  };

  return (
    <Modal
      title="Добавить оборудование"
      open={isAddModalOpen}
      onCancel={handleAddCancel}
      footer={null}
    >
      <Form form={addForm} onFinish={handleAddEquipment} layout="vertical">
        <Form.Item
          label="Наименование"
          name="name"
          rules={[{ required: true, message: 'Введите наименование' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Производитель" name="manufacturer">
          <Input />
        </Form.Item>

        <Form.Item label="Серийный номер" name="serialNumber">
          <Input />
        </Form.Item>

        <Form.Item label="Локация" name="location">
          <Select
            options={[
              { label: 'Завод Таптатты', value: 'Завод Таптатты' },
              { label: 'Завод Ондырыс', value: 'Завод Ондырыс' },
              { label: 'Магазин Таптатты', value: 'Магазин Таптатты' },
            ]}
            placeholder="Выберите локацию"
            allowClear
          />
        </Form.Item>

        <Form.Item label="Ссылка на QR-код" name="qrLink">
          <Input />
        </Form.Item>

        <Form.Item label="Ссылка на мануал" name="manualLink">
          <Input />
        </Form.Item>

        {/* Периодичности */}
        <Form.Item label="Периодичность ТО1" name="to1Frequency">
          <Select
            onChange={(value) => handleFrequencyChange('to1', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="ТО 1" name="to1">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to1} />
        </Form.Item>

        <Form.Item label="Периодичность ТО2" name="to2Frequency">
          <Select
            onChange={(value) => handleFrequencyChange('to2', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="ТО 2" name="to2">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to2} />
        </Form.Item>

        <Form.Item label="Периодичность ТО3" name="to3Frequency">
          <Select
            onChange={(value) => handleFrequencyChange('to3', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="ТО 3" name="to3">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to3} />
        </Form.Item>

        <Form.Item label="Периодичность Кап ремонта" name="majorRepairFrequency">
          <Select
            onChange={(value) => handleFrequencyChange('majorRepair', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Кап ремонт" name="majorRepair">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.majorRepair} />
        </Form.Item>

        <Form.Item label="Периодичность Поверки" name="verificationFrequency">
          <Select
            onChange={(value) => handleFrequencyChange('verification', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Поверка" name="verification">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.verification} />
        </Form.Item>

        <Form.Item label="Периодичность Калибровки" name="calibrationFrequency">
          <Select
            onChange={(value) => handleFrequencyChange('calibration', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Калибровка" name="calibration">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.calibration} />
        </Form.Item>

        <Form.Item label="Периодичность Испытаний" name="testingFrequency">
          <Select
            onChange={(value) => handleFrequencyChange('testing', value)}
          >
            <Select.Option value="Н/У">Не указано</Select.Option>
            <Select.Option value="monthly">Раз в месяц</Select.Option>
            <Select.Option value="quarterly">Раз в квартал</Select.Option>
            <Select.Option value="semi_annually">Раз в полгода</Select.Option>
            <Select.Option value="annually">Раз в год</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Испытания" name="testing">
          <DatePicker format="YYYY-MM-DD" disabled={disabledDates.testing} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Добавить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEquipmentModal;
